const CONFIGURED_API = process.env.REACT_APP_BACKEND_URL;
if (!CONFIGURED_API) throw new Error('Missing backend configuration');

// Keep API configuration authoritative. Host-only session cookies require the
// page to use that same origin, so alternate entry links redirect BEFORE bootstrap.
export function canonicalTarget(currentUrl: string, configuredApi: string = CONFIGURED_API!): string | null {
  const current = new URL(currentUrl);
  const configured = new URL(configuredApi);
  if (current.origin === configured.origin) return null;
  current.protocol = configured.protocol;
  current.host = configured.host;
  current.username = '';
  current.password = '';
  return current.href;
}

export function requireFirstPartyApi(): void {
  if (canonicalTarget(window.location.href)) {
    throw new Error('Open this workspace at its primary address to reconnect securely. No browser data has been cleared.');
  }
}